import { workforceSegmentToSelection } from '../../../../shared/user-preferences/utils/workforce-segment';
import { defineStaticListFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const CONTINGENT_WORKERS_OPTIONS = (
  ['excludeContingent', 'full', 'contingentOnly'] as const
).map((segment) => {
  const { id, name } = workforceSegmentToSelection(segment);
  return { value: id, label: name, limit: 1 };
});

export const contingentWorkersDescriptor = defineStaticListFilter({
  definition: {
    id: FilterId.CONTINGENT_WORKERS,
    name: 'Contingent Workers',
    selections: [],
    type: FilterType.STATIC_LIST,
    isVisible: true,
  },
});
